export enum BUTTON_SIZES {
  SMALL = 'small',
  REGULAR = 'regular',
}

export enum BUTTON_TYPES {
  DEFAULT = 'default',
  ICON_LEFT = 'icon-left',
}

export enum BUTTON_LAYOUTS {
  FILL = 'fill',
  HUG = 'hug',
  CENTER = 'center',
}
